import React, { useState, useEffect } from 'react';
import { notification } from '../../component/hocs/notification';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl } from '../../Mainurl';
import * as XLSX from 'xlsx/xlsx.mjs';

import { Row, Col, Card, CardHeader, CardBody, Form, Input, InputGroup, InputGroupText, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FaEye, FaSearch, } from 'react-icons/fa';

const Training = () => {
    const [mode, setMode] = useState("1");
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState('');

    const [viewModal, setViewModal] = useState(false);
    const [modalData, setModalData] = useState('');
    const [stateOpt, setStateOpt] = useState('');
    const [state, setState] = useState("0");

    useEffect(() => { get_state_list(); }, []);

    const get_state_list = () => {

        let postData = [{ "country_code": "1", "user_id": sessionStorage.getItem('user_id') }]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list2',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        <option value={row.state_code}> {row.state_name}</option>
                    )
                });

                setStateOpt(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }

    const get_training_list = (e) => {
        e.preventDefault();
        setTableData([]);
        if (state == 0) {
            let notify = notification({ message: "Select state", type: 'warn' });
            notify();
            return false;
        }
        setLoading(true);

        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "type": "1", "state_id": state, "lang_id": 1 }];
        axios({
            method: 'post',
            url: mainurl + 'Activity/event_view2',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return {
                        sl: index + 1,
                        date: row.event_date.split(" ")[0].split('-').reverse().join('-'),
                        location: row.event_loc,
                        trainer: row.user_name,
                        subject: row.subject_desc,
                        farmer_count: row.attendance,
                        action: <FaEye className='me-3 cursor' color="#FFC000" size={20} onClick={() => farmer_list_handler(row.farmer_detail)} />
                    }
                });

                setTableData(list);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }

    const farmer_list_handler = (dtl) => {

        const list = dtl.map((row, index) => {
            return {
                sl: index + 1,
                farmer_code: row.attendee_id,
                farmer_name: row.f_name + " (" + row.f_name_ne + ")"
            }
        })

        setModalData(list);
        setViewModal(true);
    }

    const download_excel_handler = () => {
        let postData = [{ "org_id": sessionStorage.getItem('org_id'), "event_type": 1 }];
        axios({
            method: 'post',
            url: mainurl + 'Traceability/farmer_event_details_ex',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return (
                        {
                            sl_no: index + 1,
                            farmer_code: row.farmer_code,
                            farmer_name: row.f_name,
                            training_date: row.event_date?.split(" ")[0].split('-').reverse().join('-'),
                            topic_desc: row.topic_desc,
                        }
                    )
                });

                if (list.length > 0) {
                    let wb = XLSX.utils.book_new(),
                        ws = XLSX.utils.json_to_sheet(list);
                    XLSX.utils.book_append_sheet(wb, ws, "Mysheet1");
                    XLSX.writeFile(wb, "training.xlsx");
                    let notify = notification({ message: "Excel downloaded successfully", type: 'success' });
                    notify();
                } else {
                    let notify = notification({ message: "No data found!", type: 'error' });
                    notify();
                }
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }


    return (
        <>
            <Header />
            <Page title='Training' breadcrumbs='Home / Training'>
                <Row className='p-3'>
                    {mode === "1" &&
                        <Col xs={12}>
                            <Card className='mb-3' color="primary" outline>
                                <CardBody>
                                    <Form onSubmit={get_training_list}>
                                        <Row>
                                            <Col sm={3} className="mb-2">
                                                <Input id="state" bsSize="sm" type="select" value={state} onChange={(e) => setState(e.target.value)}>
                                                    <option value="0"> --Select State-- </option>
                                                    {stateOpt}
                                                </Input>
                                            </Col>
                                            <Col md={2} className="mb-2">
                                                <Button className='text-white' color='primary' size="sm" block> Get Training List </Button>
                                            </Col>
                                            <Col md={2} className="mb-2">
                                                <Button className='text-white' color='primary' size="sm" onClick={download_excel_handler} block> Download Training Excel </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                            <Card className='' color="primary" outline>
                                <CardHeader>Training List <small className='text-muted'> </small></CardHeader>
                                <Col sm={{ offset: 6, size: 3 }} style={{ position: 'absolute', top: '2px', right: '2px' }}>
                                    <InputGroup size="sm">
                                        <InputGroupText> <FaSearch /> </InputGroupText>
                                        <Input type="search" placeholder='Search' />
                                    </InputGroup>
                                </Col>
                                <CardBody>
                                    <DataTable
                                        title=""
                                        customStyles={custTableStyles}
                                        columns={[
                                            {
                                                name: '#',
                                                selector: row => row.sl,
                                                sortable: true,
                                                width: '80px'
                                            },
                                            {
                                                name: 'Training Date',
                                                selector: row => row.date,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Trainer',
                                                selector: row => row.trainer,
                                                sortable: false,
                                            },
                                            {
                                                name: 'Training Subject',
                                                selector: row => row.subject,
                                                sortable: false,
                                                width: "20%"
                                            },
                                            {
                                                name: 'Attendance',
                                                selector: row => row.farmer_count,
                                                sortable: false,
                                            },
                                            {
                                                name: 'See Attendance',
                                                selector: row => row.action,
                                                sortable: false,
                                            },
                                        ]}
                                        data={tableData}
                                        highlightOnHover
                                        pagination
                                        fixedHeader
                                        progressPending={loading}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    }

                </Row>

            </Page>
            <Modal
                centered
                scrollable
                size="md"
                isOpen={viewModal}
                toggle={() => setViewModal(!viewModal)}
            >
                <ModalHeader toggle={() => setViewModal(!viewModal)}>
                    Farmer Details
                </ModalHeader>
                <ModalBody>
                    <DataTable
                        title=""
                        customStyles={custTableStyles}
                        columns={[
                            {
                                name: '#',
                                selector: row => row.sl,
                                sortable: true,
                                width: '80px'
                            },
                            {
                                name: 'Farmer Code',
                                selector: row => row.farmer_code,
                                sortable: false,
                            },
                            {
                                name: 'Farmer Name',
                                selector: row => row.farmer_name,
                                sortable: false,
                                width: "50%"
                            },
                        ]}
                        data={modalData}
                        highlightOnHover
                        pagination
                        progressPending={loading}
                    />
                </ModalBody>
            </Modal>

            <Footer />

        </>
    )

}

export default Training;